export default {
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: false
    },
    configuration: true,
    table: {
        clickModify: true,
        selectBtn: true,
        leftOperation: true,
        leftWidth: 160,
        height: 300,
        columns: [
            {
                label: '序号',
                prop: 'id',
                sort: true,
                width: 150,
                amendState: true
            },
            {
                label: '出入库类型',
                prop: 'inOutTypeName',
                sort: true,
                width: 150
            },
            {
                label: '仓库编码',
                prop: 'whCode',
                sort: true,
                width: 150
            },
            {
                label: '仓库名称',
                prop: 'whName',
                sort: true,
                width: 150
            },
            {
                label: '站点编码',
                prop: 'siteCode',
                sort: true,
                width: 182
            },
            {
                label: '站点地址',
                sort: true,
                prop: 'siteAddress',
                width: 120
            },
            {
                label: '站点类型',
                sort: true,
                prop: 'siteTypeName',
                width: 120
            },
            {
                label: '单量',
                sort: true,
                prop: 'count',
                width: 120
            },
            {
                label: '总重量(kg)',
                sort: true,
                prop: 'totalWeight',
                width: 120
            },
            {
                label: '总方量(m³)',
                prop: 'totalVolume',
                sort: true,
                width: 160
            },
            {
                label: '到车标识',
                prop: 'statusName',
                sort: true,
                width: 160
            }

        ],
        action: {
            fixedWidth: 160,
            list: [
                {
                    type: 'text',
                    label: '取消到车',
                    size: 'mini',
                    event: 'cancelArrival',
                    ifHas: '150101022',
                    displayRule: row => {
                        // 出入库类型为运输单、入库单 或 到车站点符合卡控配置
                        const inOutTypeFlag = ['YS', 'IN'].includes(row.inOutType) || row.arrivalCheckFlag;
                        // 城配订单 满足 到车标识为已处理 && 站点类型为装货 && 出入库类型为运输单、入库单 或 到车站点符合卡控配置，显示按钮
                        const condition1 = row.orderDistinctionFlag === 'CP' && row.status === '1' && row.siteType === '0' && inOutTypeFlag;
                        // 基地订单 满足 到车标识为已处理 && 站点类型为装货，显示按钮
                        const condition2 = row.orderDistinctionFlag !== 'CP' && row.status === '1' && row.siteType === '0';
                        if (condition1 || condition2) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                },
                {
                    type: 'text',
                    label: '附件管理',
                    size: 'mini',
                    event: 'attachment',
                    ifHas: '150101023',
                    displayRule: row => {
                        // 站点类型为装货
                        if (row.siteType === '0') {
                            return true;
                        }
                    }
                }
            ]
        }
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [
            10,
            20,
            30,
            50
        ]
    },
    form: {
        dispatchNo: '',
        shippingType: '',
        actualcarType: '',
        iflowStatusName: '',
        suppliersNameCn: '',
        noCarCarrierName: '',
        tranName: '',
        branchName: '',
        escoCompanyNameCn: '',
        bringBackWay: '',
        remark: '',
        infoCost: ''
    }

};
